<template>

    <div class="signature-container">


        <div class="signature-field">
            <vue-signature ref="signature" :sigOption="option" :w="'100%'" :h="'240px'"></vue-signature>
            <div class="border">
                <span>{{ $t('review-sign.sign.sign-label') }}</span>
            </div>
        </div>
        <div class="button-container">
            <button v-on:click="clear" class="transparent">{{ $t('review-sign.button.clear') }}</button>
            <button v-on:click="sign" :disabled="signButtonDisabled" class="purple">
                {{ $t('review-sign.button.sign') }}
            </button>
        </div>

    </div>

</template>


<script>

import {mapGetters} from 'vuex';
import VueSignature from 'vue-signature';

export default {
    components: {
        VueSignature,
    },
    data: () => ({
        signature: false,
        signButtonDisabled: false,
        option: {
            penColor: "rgb(0, 0, 0)",
            backgroundColor: "rgb(255,255,255)"
        }
    }),
    computed: {
        ...mapGetters([
            'getToken'
        ]),
        getContractId() {
            return this.$route.params.id;
        }
    },
    methods: {
        clear() {
            this.$refs.signature.clear()
        },
        sign() {
            if (this.$refs.signature.isEmpty()) {
                this.$swal('Signature pad is empty', [], 'error');
                return;
            }
            this.signButtonDisabled = true;

            axios({
                method: 'POST',
                url: window.config.apiUrl + 'api/contract/' + this.getContractId + '/sign',
                cancelToken: window.AuthorizationCancelSource.token,
                data: {
                    flow: 'image',
                    signature: this.$refs.signature.save('image/png')
                }
            }).then(response => {
                this.$router.push('/signing-success');
            }).finally(e => {
                this.signButtonDisabled = false;
            });
        }
    }
}


</script>


<style></style>
